import CONSTANTS from '../services/constants/constantStrings'
import store from '../store'
import AppWarn from './errors/app-warns'

export function getCookieForLogs(cookieName, addPrefix = true) {
  cookieName = (addPrefix ? CONSTANTS.KEY_PREFIX : '') + cookieName
  var matches = document.cookie.match(
    new RegExp(
      '(?:^|; )' +
        cookieName.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
        '=([^;]*)'
    )
  )
  return matches ? decodeURIComponent(matches[1]) : undefined
}

export function getCookie(cookieName, addPrefix = true) {
  try {
    cookieName = (addPrefix ? CONSTANTS.KEY_PREFIX : '') + cookieName
    var matches = document.cookie.match(
      new RegExp(
        '(?:^|; )' +
          cookieName.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
          '=([^;]*)'
      )
    )
    const cookieValue = matches ? decodeURIComponent(matches[1]) : undefined
    return cookieValue || store.state.cookieValuesCopy[cookieName]
  } catch (error) {
    const message = {
      errorMessage: `Not able to fetch the cookie: ${cookieName}, error: ${error.message}`,
      vueStateSnapshot: store.state.cookieValuesCopy
    }
    new AppWarn({
      name: 'Get Cookie',
      message: JSON.stringify(message),
      service: 'Cookie'
    })
    return store.state.cookieValuesCopy[cookieName] || undefined
  }
}

export function setCookie(name, value, options = {}, addPrefix = true) {
  try {
    name = (addPrefix ? CONSTANTS.KEY_PREFIX : '') + name
    store.dispatch('updateCookieValuesCopyState', { [name]: String(value) })
    options = {
      path: '/',
      ...options
    }
  
    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString()
    }
  
    let updatedCookie =
      encodeURIComponent(name) + '=' + encodeURIComponent(value)
  
    options['Secure'] = 'true'; // add secure flag to every cookie
    
    for (let optionKey in options) {
      updatedCookie += '; ' + optionKey
      let optionValue = options[optionKey]
      if (optionValue !== true) {
        updatedCookie += '=' + optionValue
      }
    }
  
    document.cookie = updatedCookie
  } catch(error) {
    const message = {
      errorMessage: `Not able to set the cookie: ${name} with value: ${value}, error: ${error.message}, running from application store`,
      vueStateSnapshot: store.state.cookieValuesCopy
    }
    new AppWarn({
      name: 'Set Cookie',
      message: JSON.stringify(message),
      service: 'Cookie'
    })
  }
}

export function removeCookie(name, options = {}, addPrefix = true) {
  try {
    store.dispatch('updateCookieValuesCopyState', { [name]: undefined })
    setCookie(name, '', { ...options, expires: 'Thu, 01 Jan 1970 00:00:01 GMT' }, addPrefix)
  } catch (error) {
    const message = {
      errorMessage: `Not able to remove the cookie: ${name}, error: ${error.message}`,
      vueStateSnapshot: store.state.cookieValuesCopy
    }
    new AppWarn({
      name: 'Remove Cookie',
      message: JSON.stringify(message),
      service: 'Cookie'
    })
  }
}

export function removeCookies(cookies, addPrefix = true) {
  cookies.forEach(({name, options}) => {
    removeCookie(name, options, addPrefix)
  })
}

export function setAllCookiesInVueStore() {
  try {
    document.cookie?.split(";")?.forEach(cookie => {
      const [cookieName, cookieValue] = cookie.trim().split('=')
      store.dispatch('updateCookieValuesCopyState', { [cookieName]: cookieValue })
    })
  } catch (error) {
    new AppWarn({
      name: 'Set all Cookies in Vue store',
      message: `Not able to set the cookies in vue store, error: ${error.message}`,
      service: 'Cookie'
    })
  }
}
